import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";
import { normalizarRota } from "@/lib/uso-testadoras";

const JANELA_MS = 30_000;
// Módulo: sobrevive à troca de rota (cada rota logada monta seu próprio ProtectedRoute).
const ultimaGravacao = new Map<string, number>();

export function __resetRegistroTelas() {
  ultimaGravacao.clear();
}

/** Grava por quais telas as testadoras (acesso cortesia) passam. Fire-and-forget. */
export function useRegistrarTelaTestadora() {
  const { user } = useAuth();
  const { pathname } = useLocation();

  const { data: ehTestadora } = useQuery({
    queryKey: ["sou-testadora-cortesia", user?.id],
    enabled: !!user?.id,
    staleTime: 60 * 60 * 1000,
    queryFn: async () => {
      const { data, error } = await supabase.rpc("sou_testadora_cortesia");
      if (error) return false;
      return data === true;
    },
  });

  useEffect(() => {
    if (!user?.id || ehTestadora !== true) return;
    const rota = normalizarRota(pathname);
    const chave = `${user.id}|${rota}`;
    const agora = Date.now();
    const ultima = ultimaGravacao.get(chave);
    if (ultima !== undefined && agora - ultima < JANELA_MS) return;
    ultimaGravacao.set(chave, agora);

    const gravar = async () => {
      const { error } = await supabase.from("uso_testadoras").insert({ user_id: user.id, rota });
      if (error) throw error;
    };
    void gravar().catch(console.error);
  }, [user?.id, ehTestadora, pathname]);
}
